<div class="status-{{status.toLowerCase()}}">{{'status.'+status.toLowerCase() | translate}}</div>